module.exports = __webpack_public_path__ + "static/media/Lato-LightItalic.75da51e5.svg";